import { Roles } from "@/enums";
import { IReturn, ReturnTypesEnum } from "@/interfaces/Return";

export const IS_RTO_QUERY_PARAM = "isRTO";

export const withRtoQuery = (pathname: string): string =>
  `${pathname}?${IS_RTO_QUERY_PARAM}=true`;

export const canAccessRtoListFilter = (roles: string): boolean =>
  roles.includes(Roles.DELIVERY_ROLE) ||
  roles.includes(Roles.EXPEDITION_ROLE);

export const canAccessRtoBulkPickup = (roles: string): boolean =>
  canAccessRtoListFilter(roles);

export const usesExpeditionBulkValidation = (roles: string): boolean =>
  roles.includes(Roles.EXPEDITION_ROLE) &&
  !roles.includes(Roles.DELIVERY_ROLE);

export const isRtoReturn = (return_: IReturn): boolean =>
  return_.typeTournee === ReturnTypesEnum.RTO_EMM ||
  return_.typeTournee === ReturnTypesEnum.RTO_HUB;
